export default {
  slots: {
    root: 'group',
    fieldset: 'my-1',
    item: 'cursor-pointer relative group-data-[style=native]:bg-transparent group-data-[style=native]:pl-0 pl-1.5 pr-2 group-data-[style=native]:hover:!bg-transparent group-data-[style=native]:ring-0 group-data-[style=native]:shadow-none group-data-[style=native]:border-none rounded-full py-0 float-left flex items-center hover:bg-stone-200 dark:hover:bg-stone-900 dark:bg-gray-800 bg-white shadow-sm shadow-(color:--ui-input-shadow-light) dark:shadow-(color:--ui-input-shadow-dark) ring ring-inset ring-(--ui-border-accented) duration-100 w-auto h-6 group-data-[style=native]:h-auto cursor-pointer',
    label: '-ml-2 -mr-0.5 px-1 group-data-[style=native]:mx-0 group-data-[style=native]:px-0  cursor-pointer',
    base: 'bg-white dark:bg-gray-800 hover:bg-stone-200 dark:hover:bg-stone-900 duration-300',
    description: 'text-xs -mt-0.5',
  },
  variants: {
    variant: {
      card: {
        item: 'border border-muted rounded-lg border-none h-14 !pb-5 has-data-[state=checked]:bg-primary-50 has-data-[state=checked]:ring-primary-500',
        label: 'ml-0',
        description: 'ml-1',
      },
    },
    size: {
      lg: {
        base: 'size-4',
      },
    },
  },
}